import { render, staticRenderFns } from "./musicSvg.vue?vue&type=template&id=5ae41b29"
import script from "./musicSvg.vue?vue&type=script&lang=ts"
export * from "./musicSvg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports